export const brandsLeasingReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_BRANDS_LEASING_LIST_REQUEST":
      return { ...state, loading: true, brandsLeasingList: null };
    case "GET_BRANDS_LEASING_LIST_SUCCESS":
      return { ...state, loading: false, brandsLeasingList: action.payload };
    case "GET_BRANDS_LEASING_LIST_FAILED":
      return { ...state, loading: false, brandsLeasingList: action.payload };

    case "ADD_BRANDS_LEASING_REQUEST":
      return { ...state, loading: true };
    case "ADD_BRANDS_LEASING_SUCCESS":
      return { ...state, loading: false, brandsLeasingAdd: action.payload };
    case "ADD_BRANDS_LEASING_FAILED":
      return { ...state, loading: false, brandsLeasingAdd: action.payload };

    case "UPDATE_BRANDS_LEASING_REQUEST":
      return { ...state, loading: true };
    case "UPDATE_BRANDS_LEASING_SUCCESS":
      return { ...state, loading: false, brandsLeasingUpdate: action.payload };
    case "UPDATE_BRANDS_LEASING_FAILED":
      return { ...state, loading: false, brandsLeasingUpdate: action.payload };

    case "VIEW_BRANDS_LEASING_REQUEST":
      return { ...state, loading: true };
    case "VIEW_BRANDS_LEASING_SUCCESS":
      return { ...state, loading: false, brandsLeasingView: action.payload };
    case "VIEW_BRANDS_LEASING_FAILED":
      return { ...state, loading: false, brandsLeasingView: action.payload };

    case "STATUS_UPDATE_BRANDS_LEASING_REQUEST":
      return { ...state, loading: true };
    case "STATUS_UPDATE_BRANDS_LEASING_SUCCESS":
      return { ...state, loading: false, brandsLeasingStatusUpdate: action.payload };
    case "STATUS_UPDATE_BRANDS_LEASING_FAILED":
      return { ...state, loading: false, brandsLeasingStatusUpdate: action.payload };

    default:
      return state;
  }
};